export default class Social {
    
    website = null
    facebook = null
    instagram = null
    youtube = null
    pinterest = null
    twitter = null

    constructor(website, facebook, instagram, youtube, pinterest, twitter) {
        this.website = website
        this.facebook = facebook
        this.instagram = instagram
        this.youtube = youtube
        this.pinterest = pinterest
        this.twitter = twitter
    }

    getMaskTokens()
    {
        return {
            U: { //url
                pattern: /[0-9a-zA-Z.#/]/,
                transform: v => v.toLocaleLowerCase()
            }
        }
    }

    getMaskString()
    {
        return 'https://' + 'U'.repeat(100);
    }

}